module.exports = __webpack_public_path__ + "static/media/A_bubbly_ui.e5b157b6.png";